import { Info } from 'lucide-react';
import type { OverlayTriggerState } from '@heroui/react';
import { ConfirmDialog } from '../../../components/ui/confirm-dialog';

interface CancelRequestModalProps {
  state: OverlayTriggerState;
  onConfirm: () => Promise<void>;
}

export function CancelRequestModal({ state, onConfirm }: CancelRequestModalProps) {
  return (
    <ConfirmDialog
      state={state}
      title="Cancelar solicitação"
      cancelLabel="Manter solicitação"
      confirmLabel="Cancelar solicitação"
      onConfirm={onConfirm}
      message={
        <>
          <p className="text-muted">
            Tem certeza que deseja cancelar esta solicitação de uso da vaga?
          </p>
          <p className="mt-2 flex items-start gap-1 text-sm text-muted">
            <Info size={14} className="mt-0.5 shrink-0" />A vaga ficará disponível para outro
            condômino após o cancelamento.
          </p>
        </>
      }
    />
  );
}
